import { ShieldCheck, Hammer, Activity, Award } from "lucide-react";
import { SloganQuote } from "@/components/SloganQuote";

const badges = [
  { icon: Hammer, label: "Montaj în condiții extreme" },
  { icon: Activity, label: "Intervenții în miez de noapte" },
  { icon: ShieldCheck, label: "Soluții testate în teren" },
];

export default function FieldExperience() {
  return (
    <section className="bg-slate-900 text-white border-t border-slate-800" data-testid="field-experience-section">
      <div className="max-w-5xl mx-auto px-6 py-24">
        <div className="flex items-center gap-3 mb-8">
          <Award className="w-6 h-6 text-orange-500" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-orange-500">Experiență reală</span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter leading-[1.05] max-w-3xl">
          25+ ani de realitate pe teren.
          <span className="block text-slate-500 mt-1">Dincolo de formulele teoretice.</span>
        </h2>

        <SloganQuote sloganKey="slogan_workplace" dark testid="about-slogan" className="mt-8 max-w-3xl text-lg sm:text-xl" />

        <div className="mt-10 space-y-6 text-slate-300 leading-relaxed text-lg max-w-3xl">
          <p>
            În peste un sfert de secol de activitate, am văzut și am rezolvat aproape orice situație posibilă în fabrici și pe șantiere izolate.
            Am montat utilaje complexe în condiții de viscol, am salvat linii de producție blocate în miez de noapte și, da, am dus la bun sfârșit
            proiecte chiar și în timp ce urmam o serie de injecții antitetanice în urma unei mușcături de câine pe un șantier.
          </p>
          <p>
            Când colaborezi cu <span className="text-white font-semibold">OXO</span> sau apelezi la directorul nostru de experți, nu cumperi doar
            software sau structuri metalice — cumperi <span className="text-white font-semibold">25 de ani de rezistență, adaptabilitate și soluții
            testate în cele mai dure condiții reale</span>.
          </p>
        </div>

        <blockquote className="border-l-2 border-orange-600 pl-5 mt-10 max-w-2xl">
          <p className="text-xl sm:text-2xl font-bold text-white italic leading-snug">
            „Pentru că în industria grea, experiența adevărată se măsoară în cicatrici și proiecte funcționale."
          </p>
        </blockquote>

        <div className="flex flex-wrap gap-3 mt-12">
          {badges.map((b) => (
            <span key={b.label} className="inline-flex items-center gap-2 border border-slate-700 bg-slate-950/40 px-4 py-2.5 text-sm text-slate-300">
              <b.icon className="w-4 h-4 text-orange-500" /> {b.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
